import Chip, { ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

import { resolveTagPalette, tagChipStyles } from './tagChipStyles';

export const ChipStyled = styled(Chip)((
  props: ChipProps & { bgColor?: string; isSystem?: boolean }
) => {
  // Same resolution the base styling uses. These two rules previously read the
  // raw stored colour, so hovering an editable tag snapped it back to the old
  // saturated fill and the delete icon stayed the pre-pastel colour.
  const { bg, text } = resolveTagPalette(props.bgColor);
  return {
    ...tagChipStyles(props.bgColor, props.isSystem),
    '&&:hover, &&:focus': {
      backgroundColor: bg,
    },
    '& .MuiChip-deleteIcon': {
      color: text,
      opacity: 0.6,
      fontSize: 15,
    },
  };
});
